import React, { Component } from "react";
import { Form, Row, Col } from "antd";
import moment from "moment";
import { CustomerInfomation } from "./customer-infomation/customer-infomation";
import { BranchManager } from "./branch-manager/branch-manager";
import { VehicleInfomation } from "./vehicle-information/vehicle-information";
import { RentalPeriod } from "./rental-period/rental-period";
import { apiContract } from "../../../../api/api-contract";
import { TypeOfRental } from "./type-of-rental/type-of-rental";
import { FirstHalfRates } from "./rental-rates-surcharge/first-half-rates";
import { EndHalfRates } from "./rental-rates-surcharge/end-half-rates";
import { VatFee } from "./vat-fee/vat-fee";
import { RentalConditions } from "./rental-conditions/rental-conditions";
import { Punishment } from "./punishment/punishment";
import { ContractNote } from "./contract-note/contract-note";
import { Deposit } from "./deposit/deposit";
import { ContractCode } from "./contract-code/contract-code";
import { SignDate } from "./sign-date/sign-date";
import { BottomButton } from "./bottom-button/bottom-button";
import { ContractAnnex } from "./contract-annex/contract-annex";
import { SuccessContractInsert } from "./modal/success-contract-insert";
import { ContractTitle } from "./contract-title/contract-title";
import { EditHistory } from "./edit-history/edit-history";
import { AddCustomer } from "./modal/add-customer";
import {
  contractSubmit,
  initValues,
  convertContract,
  checkChangeFormValue,
} from "./contract-event";
import { CONTRACT_TYPE } from "../../../../common/utils/static-data";

const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};

//Sử dụng Ref cho vấn đề cập nhật lại UI trong các Component con
export class ContractNew extends Component {
  initFormValue = null;
  contractParam = null;
  dataOptions = null;
  state = {
    include_appendix: false,
    contract_status: null,
    limitEdit: true, // xử lý state của các trường bị phụ thuộc hiệu lực
    unlimitEdit: true, // xử lý state của các trường ko bị phụ thuộc hiệu lực
    isEdit: true, // xử lý state của các trường disable khi edit
    editPage: false, // xử lý state phân biết edit or detail page with new contract
    disabledOk: false,
    isShowContractAnnex: false,
    isEditHistory: false, // xử lý state chuyen sang man history
    contractUserId: 0,
    typeOption: "create_new",
  };

  async componentDidMount() {
    const contractOptions = await apiContract.getContractOptions();
    if (contractOptions.status === "success") {
      this.dataOptions = contractOptions.data;
      this.setOptionState();
    }
  }

  setOptionState = () => {
    if (!this.dataOptions) {
      return;
    }
    const {
      branches,
      fuel_types,
      rental_service_types,
      working_day_types,
      over_time_policies,
    } = this.dataOptions;
    this.branch &&
      this.branch.setState({
        branchs: branches.map((item) => {
          return { ...item, name: item.code };
        }),
      });
    this.typeOfRental && this.typeOfRental.setState({ rental_service_types });
    this.endHalfRates &&
      this.endHalfRates.setState({
        over_time_policies: over_time_policies.polices,
      });
    this.rentalConditions &&
      this.rentalConditions.setState({ working_day_types, fuel_types }, () => {
        if (this.contractParam) {
          const { vehicle } = this.contractParam;
          if (vehicle && vehicle.fuel_type_group_id) {
            this.setFuelCodes(vehicle.fuel_type_group_id);
          }
        }
      });
  };

  addVehicleInSuccess = (data) => {
    this.contractCode.getContractData(data);
  };

  addNewContractSuccess = () => {
    convertContract(
      {
        contract_code: {
          prefix_code: "",
          suffix_code: "001",
        },
        works_time: [moment("07:00", "HH:ss"), moment("18:00", "HH:ss")],
        works_time_holiday: [
          moment("07:00", "HH:ss"),
          moment("18:00", "HH:ss"),
        ],
        sign_date: moment(),
        from_datetime: moment().add(1, "day"),
        to_datetime: moment().add(2, "day"),
      },
      this
    );
  };

  submit = () => {
    contractSubmit(this);
  };

  onChangeForm = (feild, value) => {
    this.form &&
      this.form.setFieldsValue({
        [feild]: value,
      });
    if (this.state.editPage) {
      checkChangeFormValue(this);
    }
  };

  cancelEditContract = () => {
    if (this.contractParam) this.updateForm(this.contractParam);
  };

  updateForm = (contract, typeOption) => {
    if (contract.id) {
      this.setState({
        contractUserId: contract.created_by.id,
        typeOption: typeOption,
      });
    }

    if (contract.limitEdit !== undefined) {
      this.contractParam = contract;

      this.setState(
        {
          limitEdit: contract.limitEdit,
          unlimitEdit: contract.unlimitEdit,
          isEdit: contract.isEdit,
          editPage: true,
          isEditHistory: false,
          isShowContractAnnex: false,
          idContract: contract.id,
          include_appendix: contract.include_appendix,
          contract_status: contract.status,
        },
        () => {
          this.setOptionState();
          this.bottomBottom.setState({ type: "DETAIL_EDIT" });
          convertContract(contract, this, true);
        }
      );

      return;
    }
    convertContract(contract, this);
    this.form.validateFields(["user"]); // truơngf user trong form là 1 trường đặc biệt cần validate lại ở đây
  };

  enableEditContract = () => {
    this.bottomBottom.setState({ type: "EDIT" });
    this.setState({
      limitEdit: true,
      unlimitEdit: true,
      isShowContractAnnex: true,
    });
  };

  onValuesChange = () => {
    if (this.state.editPage) {
      checkChangeFormValue(this);
      //effective_date
    }
  };

  handleGoToEditHistory = (status) => this.setState({ isEditHistory: status });

  validateFields = (fields) => {
    if (this.form) return this.form.validateFields(fields);
  };

  getFormValues = () => {
    return this.form.getFieldsValue();
  };

  showAddCustomerModal = () => {
    this.addCustomer.visiableModal(true);
  };

  setCustomerOnModal = (customer) => {
    const { customer_type } = customer;
    this.customerInfo.setState({
      customer_info: { ...customer, phone_number: customer.phone_number },
      isDisableUser: customer_type.code === "CT002" ? false : true,
      user: {
        email: customer.email,
        mobile: customer.phone_number,
        id: customer.admin_id,
        name: customer.admin_name,
        country_code: customer.country_code,
      },
      optionsCompany: [],
      optionsUser: [],
    });
    this.form.setFieldsValue({
      customer_info: customer ? customer.name : "",
      user: customer.admin_name ? customer.admin_name : "",
    });
  };

  setFuelCodes = (fuel_type_group_id) => {
    if (!this.rentalConditions) {
      return;
    }
    const { state } = this.rentalConditions;
    const { fuel_types } = state;
    const newFuelList = fuel_types.map((value) => {
      const findFuleCode = fuel_type_group_id
        ? fuel_type_group_id === value.fuel_type_group_id
        : true;

      return {
        ...value,
        warning: findFuleCode ? false : true,
      };
    });
    this.rentalConditions.setState({ fuel_types: newFuelList });
  };

  render() {
    const {
      contract_status,
      disabledOk,
      limitEdit,
      unlimitEdit,
      isEdit,
      editPage,
      isEditHistory,
      idContract,
      include_appendix,
      isShowContractAnnex,
      contractUserId,
      typeOption,
    } = this.state;
    const auth = localStorage.getItem("persist:root");
    const userId = JSON.parse(JSON.parse(auth).auth).id;
    const role = JSON.parse(JSON.parse(auth).auth).roles[0];
    return (
      <div className="contract-new">
        <ContractTitle
          contract_type={CONTRACT_TYPE.has_driver}
          showAddCustomerModal={this.showAddCustomerModal}
          include_appendix={include_appendix}
          goToDetail={this.cancelEditContract}
          close={this.props.close}
          contract_status={contract_status}
          isEditHistory={isEditHistory}
          editPage={editPage}
          isEdit={unlimitEdit || limitEdit}
        />
        {isEditHistory ? (
          <EditHistory
            contractParam={this.contractParam}
            idContract={idContract}
          />
        ) : (
          <>
            <Form
              onValuesChange={this.onValuesChange}
              scrollToFirstError
              initialValues={initValues(true)}
              ref={(ref) => (this.form = ref)}
              {...layout}
            >
              <Row gutter={24}>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <ContractCode
                    contract_type={CONTRACT_TYPE.has_driver}
                    getFormValues={this.getFormValues}
                    isEdit={isEdit}
                    updateForm={this.updateForm}
                    onChangeForm={this.onChangeForm}
                    validateFields={this.validateFields}
                    ref={(ref) => (this.contractCode = ref)}
                  />
                  <BranchManager
                    contract_type={CONTRACT_TYPE.has_driver}
                    unlimitEdit={unlimitEdit}
                    onChangeForm={this.onChangeForm}
                    ref={(ref) => (this.branch = ref)}
                  />
                  <SignDate
                    unlimitEdit={unlimitEdit}
                    ref={(ref) => (this.signDate = ref)}
                  />
                  <CustomerInfomation
                    isEdit={isEdit}
                    typeOption={typeOption}
                    isOwner={
                      userId === contractUserId || role === "Superuser"
                        ? true
                        : false
                    }
                    validateFields={this.validateFields}
                    onChangeForm={this.onChangeForm}
                    ref={(ref) => (this.customerInfo = ref)}
                  />
                  <VehicleInfomation
                    contract_type={CONTRACT_TYPE.has_driver}
                    unlimitEdit={unlimitEdit}
                    editPage={editPage}
                    setFuelCodes={this.setFuelCodes}
                    validateFields={this.validateFields}
                    onChangeForm={this.onChangeForm}
                    checkChangeFormValue={() => checkChangeFormValue(this)}
                    ref={(ref) => (this.vehicleInfo = ref)}
                  />
                  <RentalPeriod
                    contractParam={this.contractParam}
                    unlimitEdit={unlimitEdit}
                    ref={(ref) => (this.rentalPeriod = ref)}
                  />
                  <TypeOfRental
                    limitEdit={limitEdit}
                    onChangeForm={this.onChangeForm}
                    ref={(ref) => (this.typeOfRental = ref)}
                  />
                  <FirstHalfRates
                    typeOption={typeOption}
                    isOwner={
                      userId === contractUserId || role === "Superuser"
                        ? true
                        : false
                    }
                    limitEdit={limitEdit}
                    editPage={editPage}
                    isEdit={isEdit}
                    checkChangeFormValue={() => checkChangeFormValue(this)}
                    onChangeForm={this.onChangeForm}
                    ref={(ref) => (this.firstRates = ref)}
                  />
                </Col>

                <Col
                  className="right-container"
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                >
                  <EndHalfRates
                    typeOption={typeOption}
                    isOwner={
                      userId === contractUserId || role === "Superuser"
                        ? true
                        : false
                    }
                    isEdit={isEdit}
                    limitEdit={limitEdit}
                    onChangeForm={this.onChangeForm}
                    ref={(ref) => (this.endHalfRates = ref)}
                  />
                  <Deposit
                    typeOption={typeOption}
                    isOwner={
                      userId === contractUserId || role === "Superuser"
                        ? true
                        : false
                    }
                    unlimitEdit={unlimitEdit}
                    ref={(ref) => (this.deposit = ref)}
                  />
                  <VatFee
                    typeOption={typeOption}
                    isOwner={
                      userId === contractUserId || role === "Superuser"
                        ? true
                        : false
                    }
                    isEdit={isEdit}
                    ref={(ref) => (this.vatFee = ref)}
                  />
                  <RentalConditions
                    typeOption={typeOption}
                    isOwner={
                      userId === contractUserId || role === "Superuser"
                        ? true
                        : false
                    }
                    unlimitEdit={unlimitEdit}
                    limitEdit={limitEdit}
                    editPage={editPage}
                    isEdit={isEdit}
                    checkChangeFormValue={() => checkChangeFormValue(this)}
                    onChangeForm={this.onChangeForm}
                    ref={(ref) => (this.rentalConditions = ref)}
                  />
                  <Punishment
                    typeOption={typeOption}
                    isOwner={
                      userId === contractUserId || role === "Superuser"
                        ? true
                        : false
                    }
                    unlimitEdit={unlimitEdit}
                    onChangeForm={this.onChangeForm}
                    ref={(ref) => (this.punishment = ref)}
                  />
                  <ContractNote
                    unlimitEdit={unlimitEdit}
                    ref={(ref) => (this.contractNote = ref)}
                  />
                  {isShowContractAnnex && (
                    <ContractAnnex
                      unlimitEdit={unlimitEdit}
                      limitEdit={limitEdit}
                      ref={(ref) => (this.contractAnnex = ref)}
                    />
                  )}
                </Col>
              </Row>
            </Form>
            <BottomButton
              ref={(ref) => (this.bottomBottom = ref)}
              submit={this.submit}
              enableEditContract={this.enableEditContract}
              close={this.props.close}
              contractParam={this.contractParam}
              cancelEditContract={this.cancelEditContract}
              handleGoToEditHistory={this.handleGoToEditHistory}
              disabledOk={disabledOk}
            />
            <SuccessContractInsert ref={(ref) => (this.successModal = ref)} />
            <AddCustomer
              setCustomerOnModal={this.setCustomerOnModal}
              ref={(ref) => (this.addCustomer = ref)}
            />
          </>
        )}
      </div>
    );
  }
}
